// extracted by mini-css-extract-plugin
export default {"block":"DownloadBlock_block__4JGXP","titleText":"DownloadBlock_titleText__OG79e","badge":"DownloadBlock_badge__Kaz9x","actions":"DownloadBlock_actions__3axCr"};